import {Component} from "@angular/core";
import {Teams} from "src/data/competition-data";
import {NavParams} from "@ionic/angular";
/**
 * Created by ashok on 19/12/16.
 */
@Component({
    templateUrl: './competition-team-expand-logo.html',
    selector: 'competition-team-expand-logo'
})
export class CompetitionTeamExpandLogo
{
    team: Teams;

    constructor(private navParams: NavParams) {
        // this.viewCtrl  = viewCtrl;
        this.navParams = navParams;
        //this.varThing1 = this.navParams.get('param1');
        this.team      = navParams.get("team");
    }

    close() {
        // this.viewCtrl.dismiss();
    }
}
